<ng-container *ngIf="!!get">
    <tt-tabs #tabs>
        <tt-tab ttId="SIMPLE" ttLabel="productcreate_gb_details_simple"></tt-tab>
        <tt-tab ttId="ALL" ttLabel="productcreate_gb_details_all"></tt-tab>
    </tt-tabs>
    <div [hidden]="tabs.ttSelectedId !== 'SIMPLE'">
        <div class="col-xs-12 col-md-6 sp-0">
            <tt-card class="col-xs-12 p-5">
                <tt-search
                    ttLabel="product_search_copy_from"
                    [(ttModel)]="get.product_search"
                    [ttSearch]="searchProducts"
                    (ttOnSelected)="onProductSelected($event)"
                    (ttOnClear)="onProductSelected()"
                ></tt-search>
                <tt-checkbox [hidden]="!get.prod_id_copy_from" ttRememberId="w_productcreate.copy_components" ttLabel="copy_components" [(ttModel)]="get.copy_components"></tt-checkbox>
                <tt-select
                    *ngIf="get.setting_productsetting_list_filter_by_prodtype === '1'"
                    ttRequired
                    ttLabel="prodtype"
                    [(ttModel)]="get.prodtype_no"
                    (ttModelChange)="loadProductSettings()"
                    [ttData]="productTypes"
                    ttDataId="prodtype_no"
                    ttDataName="prodtype_name"
                ></tt-select>
                <tt-select
                    ttRequired
                    ttLabel="productsetting"
                    [(ttModel)]="get.productsetting_keyno"
                    (ttModelChange)="onProductSettingChanged()"
                    [ttData]="productSettings"
                    ttDataId="item_id"
                    ttDataName="item_name"
                >
                    <ng-container buttons *ngIf="get.access_productsetting === '1'">
                        <tt-form-field-button ttIcon="far fa-bars" ttGoto="productsettings"></tt-form-field-button>
                        <tt-form-field-button ttIcon="far fa-chevron-right" ttGoto="productsetting" [ttGotoParms]="{ productsetting_keyno: get.productsetting_keyno }"></tt-form-field-button>
                    </ng-container>
                </tt-select>
                <!-- <ng-container *ngIf="get.new_number_assigned === '0'"> -->
                <tt-input ttLabel="prod_id" [(ttModel)]="get.prod_id" (ttModelChange)="loadExistingProdIds()" ttDebounceTime="500">
                    <tt-form-field-button buttons ttIcon="far fa-plus" (ttClick)="getProdId()"></tt-form-field-button>
                </tt-input>
                <tt-search-multi-select ttModelSetting="stringId" ttSeparatorKey=", " ttLabel="existing_prod_ids" [ttModel]="get.existing_prod_ids ?? ''" ttReadonly></tt-search-multi-select>
                <!-- </ng-container> -->
                <!-- <tt-input *ngIf="get.new_number_assigned === '1'" ttRequired ttLabel="prod_id" [ttModel]="get.prod_id" ttReadonly></tt-input> -->
                <tt-input ttRequired ttLabel="prod_name" [(ttModel)]="get.prod_name" [ttReadonly]="get.protected_prod_name === '1'"></tt-input>
                <tt-select
                    ttRequired
                    ttLabel="prodgrp"
                    [(ttModel)]="get.prodgrp_id"
                    (ttModelChange)="onProductGroupChanged()"
                    [ttData]="productGroups"
                    ttDataId="prodgrp_id"
                    ttDataName="prodgrp_name"
                    [ttClearValue]="''"
                    [ttShowClearButton]="get.prodgrp_id > ''"
                >
                    <ng-container buttons>
                        <tt-form-field-button ttIcon="far fa-bars" ttGoto="prodgrps"></tt-form-field-button>
                        <tt-form-field-button ttIcon="far fa-chevron-right" ttGoto="prodgrpmenu" [ttGotoParms]="{ prodgrp_id: get.prodgrp_id }"></tt-form-field-button>
                    </ng-container>
                </tt-select>
                <tt-select
                    [hidden]="productGroup2s.length === 0"
                    ttLabel="prodgrp2"
                    [(ttModel)]="get.prodgrp2_id"
                    (ttModelChange)="onProductGroup2Changed()"
                    [ttData]="productGroup2s"
                    ttDataId="item_id"
                    ttDataName="item_name"
                    [ttClearValue]="''"
                    [ttShowClearButton]="get.prodgrp2_id > ''"
                ></tt-select>
                <tt-select
                    [hidden]="productGroup3s.length === 0"
                    ttLabel="prodgrp3"
                    [(ttModel)]="get.prodgrp3_id"
                    (ttModelChange)="onProductGroup3Changed()"
                    [ttData]="productGroup3s"
                    ttDataId="item_id"
                    ttDataName="item_name"
                    [ttClearValue]="''"
                    [ttShowClearButton]="get.prodgrp3_id > ''"
                ></tt-select>
                <tt-select
                    [hidden]="productGroup4s.length === 0"
                    ttLabel="prodgrp4"
                    [(ttModel)]="get.prodgrp4_id"
                    [ttData]="productGroup4s"
                    ttDataId="item_id"
                    ttDataName="item_name"
                    [ttClearValue]="''"
                    [ttShowClearButton]="get.prodgrp4_id > ''"
                ></tt-select>
                <tt-input *ngIf="get.show_drawing_no === '1'" ttLabel="drawing_no" [(ttModel)]="get.drawing_no"></tt-input>
                <tt-textarea *ngIf="get.show_prod_designinfo === '1'" ttLabel="prod_designinfo" [(ttModel)]="get.prod_designinfo"></tt-textarea>
                <tt-textarea *ngIf="get.show_note === '1'" ttLabel="note" [(ttModel)]="get.note"></tt-textarea>
            </tt-card>

            <tt-card class="col-xs-12 p-5" [hidden]="pimFields.length === 0" [ttHeading]="get.grouptext_pim_fields" ttTranslateHeading="false">
                <tt-product-setting-mcs-form [(data)]="pimFields" [items]="pimFieldsItems" (blur)="onPimFieldsChange()"></tt-product-setting-mcs-form>
            </tt-card>

            <tt-card class="col-xs-12 p-5" [hidden]="conversionUnits.length === 0" [ttHeading]="get.grouptext_unit_conversion" ttTranslateHeading="false">
                <tt-input-number
                    *ngFor="let unit of conversionUnits"
                    ttRequired
                    [ttLabel]="unit.inversevalue === '1' ? unit.qtyfactor_name_inverse : unit.qtyfactor_name"
                    ttTranslateLabel="false"
                    [(ttModel)]="unit.qtyfactor"
                    (ttOnBlur)="loadSalesPrice$.next(get)"
                    ttTextAlign="right"
                    ttDecimals="6"
                >
                    <tt-form-field-button buttons ttIcon="far fa-exchange" (ttClick)="setConversionInversed(unit)"></tt-form-field-button>
                </tt-input-number>
            </tt-card>
        </div>
        <div class="col-xs-12 col-md-6 sp-0">
            <tt-card class="col-xs-12 p-5" *ngIf="get.prodtype_no === '0' || get.prodtype_no === '3'" [ttHeading]="get.grouptext_purchase" ttTranslateHeading="false">
                <tt-search
                    ttLabel="searchtext_supplier"
                    [(ttModel)]="get.searchtext_supplier"
                    [ttSearch]="searchSuppliers"
                    (ttOnSelected)="onSupplierSelected($event)"
                    (ttOnClear)="onSupplierSelected()"
                ></tt-search>
                <tt-input-number ttLabel="supplier_no" [(ttModel)]="get.supplier_no" (ttModelChange)="loadSalesPrice$.next(get)">
                    <ng-container buttons *ngIf="get.supplier_no > '0'">
                        <tt-form-field-button ttIcon="far fa-chevron-right" ttGoto="customersmenu" [ttGotoParms]="{ cust_no: get.supplier_no }"></tt-form-field-button>
                    </ng-container>
                </tt-input-number>
                <div [hidden]="get.searchtext_supplier === ''">
                    <tt-input ttRequired ttLabel="suppliers_prodno" [(ttModel)]="get.suppliers_prodno"></tt-input>
                    <tt-input ttLabel="suppliers_prodname" [(ttModel)]="get.suppliers_prodname"></tt-input>
                </div>
                <ng-container *ngIf="get.supplier_no > '0'">
                    <tt-input-number
                        ttLabel="fullprice_val"
                        [(ttModel)]="get.fullprice_val"
                        (ttModelChange)="recalculateSuppliersPrice(); loadSalesPrice$.next(get)"
                        ttTextAlign="right"
                        ttDecimals="2"
                    ></tt-input-number>
                    <tt-input-number
                        ttLabel="purch_discount"
                        [(ttModel)]="get.purch_discount"
                        (ttModelChange)="recalculateSuppliersPrice(); loadSalesPrice$.next(get)"
                        ttTextAlign="right"
                        ttDecimals="2"
                    ></tt-input-number>
                    <tt-input-number
                        ttLabel="suppliers_price"
                        [ttSublabel]="get.suppliers_valuta"
                        ttTranslateSublabel="false"
                        [(ttModel)]="get.suppliers_price"
                        (ttModelChange)="loadSalesPrice$.next(get)"
                        ttTextAlign="right"
                        ttDecimals="2"
                    ></tt-input-number>
                </ng-container>
            </tt-card>
            <tt-card class="col-xs-12 p-5" [ttHeading]="get.grouptext_sales_price" ttTranslateHeading="false">
                <tt-select
                    *ngIf="get.show_discgrpprod === '1'"
                    ttLabel="discgrpprod"
                    [(ttModel)]="get.discgrpprod_keyno"
                    (ttModelChange)="loadDiscountInfo$.next(get)"
                    [ttData]="discountGroupsProducts"
                    ttDataId="discgrpprod_keyno"
                    ttDataName="discgrpprod_name"
                >
                    <ng-container *ngIf="get.discgrpprod_keyno > '0'" buttons>
                        <tt-form-field-button ttIcon="far fa-chevron-right" ttGoto="discgrpprod" [ttGotoParms]="{ discgrpprod_keyno: get.discgrpprod_keyno }"></tt-form-field-button>
                    </ng-container>
                </tt-select>
                <div [hidden]="get.supplier_no <= '0'">
                    <tt-select
                        ttLabel="pricemethod"
                        [(ttModel)]="get.pricemethod_id"
                        (ttModelChange)="loadSalesPrice$.next(get)"
                        [ttData]="priceMethods"
                        ttDataId="pricemethod_id"
                        ttDataName="pricemethod_name"
                    ></tt-select>
                    <tt-input-number
                        *ngIf="get.pricemethod_id === '1'"
                        ttLabel="calc_margin_pst"
                        [(ttModel)]="get.calc_margin_pst"
                        (ttModelChange)="loadSalesPrice$.next(get)"
                        ttTextAlign="right"
                        ttDecimals="4"
                    ></tt-input-number>
                    <tt-input-number
                        *ngIf="get.pricemethod_id === '2'"
                        ttLabel="calc_factor"
                        [(ttModel)]="get.calc_factor"
                        (ttModelChange)="loadSalesPrice$.next(get)"
                        ttTextAlign="right"
                        ttDecimals="4"
                    ></tt-input-number>
                </div>
                <tt-select
                    ttRememberId="w_productcreate.pricelist_id"
                    ttLabel="pricelist"
                    [(ttModel)]="get.pricelist_id"
                    (ttModelChange)="loadSalesPrice$.next(get)"
                    [ttData]="pricelists"
                    ttDataId="item_id"
                    ttDataName="item_name"
                ></tt-select>
                <tt-input-number
                    ttLabel="pricelist_price"
                    [(ttModel)]="get.pricelist_price"
                    (ttModelChange)="loadSalesPrice$.next(get)"
                    ttTextAlign="right"
                    ttDecimals="2"
                    [ttReadonly]="get.pricemethod_id !== '4' && get.supplier_no > '0'"
                ></tt-input-number>
                <tt-input-number
                    *ngIf="get.basecurrency_id !== get.pricelist_valuta_id"
                    ttLabel="pricelist_price_locval"
                    [ttModel]="get.pricelist_price_locval"
                    ttTextAlign="right"
                    ttDecimals="2"
                    ttReadonly
                ></tt-input-number>
                <ng-container *ngIf="get.supplier_no > '0'">
                    <tt-input-number ttLabel="cost_locval" [(ttModel)]="get.cost_locval" ttTextAlign="right" ttDecimals="2" ttReadonly></tt-input-number>
                    <tt-input-number ttLabel="db_amount_locval" [(ttModel)]="get.db_amount_locval" ttTextAlign="right" ttDecimals="2" ttReadonly></tt-input-number>
                    <tt-input-number ttLabel="db_pst" [(ttModel)]="get.db_pst" ttTextAlign="right" ttDecimals="2" ttReadonly></tt-input-number>
                </ng-container>
                <tt-checkbox *ngIf="get.show_custom_check_01 === '1'" ttLabel="custom_check_01" [(ttModel)]="get.custom_check_01"></tt-checkbox>
            </tt-card>
        </div>
    </div>
    <tt-card [hidden]="tabs.ttSelectedId !== 'ALL'" class="col-xs-12 col-md-6 sp-5" style="margin-top: 5px; margin-bottom: 5px">
        <tt-select
            *ngIf="get.setting_productsetting_list_filter_by_prodtype === '0'"
            ttRequired
            ttLabel="prodtype"
            [(ttModel)]="get.prodtype_no"
            (ttModelChange)="loadProductSettings()"
            [ttData]="productTypes"
            ttDataId="prodtype_no"
            ttDataName="prodtype_name"
        ></tt-select>
        <tt-select ttRequired ttLabel="stock_unit" [(ttModel)]="get.stock_unit_no" (ttModelChange)="loadConversionUnits()" [ttData]="units" ttDataId="unit_no" ttDataName="unit_name"></tt-select>
        <tt-select
            ttLabel="stockcount_unit"
            [(ttModel)]="get.stockcount_unit_no"
            (ttModelChange)="loadConversionUnits(); loadSalesPrice$.next(get)"
            [ttData]="units"
            ttDataId="unit_no"
            ttDataName="unit_name"
        ></tt-select>
        <tt-select
            ttLabel="purch_price_unit"
            [(ttModel)]="get.purch_price_unit_no"
            (ttModelChange)="loadConversionUnits(); loadSalesPrice$.next(get)"
            [ttData]="units"
            ttDataId="unit_no"
            ttDataName="unit_name"
        ></tt-select>
        <tt-select
            ttLabel="sales_price_unit"
            [(ttModel)]="get.sales_price_unit_no"
            (ttModelChange)="loadConversionUnits(); loadSalesPrice$.next(get)"
            [ttData]="units"
            ttDataId="unit_no"
            ttDataName="unit_name"
        ></tt-select>
        <tt-select
            ttLabel="purch_number_unit"
            [(ttModel)]="get.purch_number_unit_no"
            (ttModelChange)="loadConversionUnits(); loadSalesPrice$.next(get)"
            [ttData]="units"
            ttDataId="unit_no"
            ttDataName="unit_name"
        ></tt-select>
        <tt-select ttRequired ttLabel="businessco" [(ttModel)]="get.businessco_no" [ttData]="companies" ttDataId="businessco_no" ttDataName="company_name"></tt-select>
        <tt-select
            ttRequired
            ttLabel="pohcompletionmethod"
            [(ttModel)]="get.pohcompletionmethod_keyno"
            [ttData]="pohCompletionMethods"
            ttDataId="pohcompletionmethod_keyno"
            ttDataName="pohcompletionmethod_name"
        ></tt-select>
        <tt-select
            ttRequired
            ttLabel="pohcompletionprinciple"
            [(ttModel)]="get.pohcompletionprinciple_keyno"
            [ttData]="pohCompletionPrinciples"
            ttDataId="pohcompletionprinciple_keyno"
            ttDataName="pohcompletionprinciple_name"
        ></tt-select>
        <tt-select ttRequired ttLabel="prodbeomethod" [(ttModel)]="get.prodbeomethod_no" [ttData]="productionOrderMethods" ttDataId="prodbeomethod_no" ttDataName="prodbeomethod_name"></tt-select>
        <tt-select ttLabel="planpolicy" [(ttModel)]="get.planpolicy_no" [ttData]="planPolicies" ttDataId="planpolicy_no" ttDataName="planpolicy_name"></tt-select>
        <tt-checkbox ttLabel="warning_on_pick_as_component_outside_structure" [(ttModel)]="get.warning_on_pick_as_component_outside_structure"></tt-checkbox>
        <tt-checkbox ttLabel="manage_stockquantity_pr_batch" [(ttModel)]="get.manage_stockquantity_pr_batch"></tt-checkbox>
        <tt-select ttLabel="prodplace" [(ttModel)]="get.prodplace_id" [ttData]="productionPlaces" ttDataId="prodplace_id" ttDataName="prodplace_name"></tt-select>
    </tt-card>

    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-6 p-5">
            <tt-button-save (ttClick)="save()" [ttLoading]="saving"></tt-button-save>
            <tt-button-settings *ngIf="get.show_setting === '1'"></tt-button-settings>
        </tt-card>
    </div>
</ng-container>
